import { EditableFmeaRow } from '../types';

export const generateAiTasks = async (
    items: EditableFmeaRow[],
    updateItems: (items: EditableFmeaRow[]) => void
) => {
    // 1. Identify high-risk items without tasks
    const highRiskItems = items.filter(item => {
        const s = Number(item.S) || 0;
        const o = Number(item.O) || 0;
        const d = Number(item.D) || 0;
        const rpn = s * o * d;
        const hasTask = Boolean(item.recommendedAction?.trim());
        return (rpn >= 100 || s >= 8 || item.actionPriority === 'H') && !hasTask;
    });

    if (highRiskItems.length === 0) {
        alert("No high-risk items missing tasks found.");
        return;
    }

    // Simulate AI Call
    alert(`Generating tasks for ${highRiskItems.length} high-risk items using AI Model...`);

    // 2. Map and update items
    const updatedItems = items.map(item => {
        const s = Number(item.S) || 0;
        const o = Number(item.O) || 0;
        const d = Number(item.D) || 0;
        const rpn = s * o * d;
        const hasTask = Boolean(item.recommendedAction?.trim());

        if ((rpn >= 100 || s >= 8 || item.actionPriority === 'H') && !hasTask) {
            return {
                ...item,
                recommendedAction: `AI Suggested: Implement poka-yoke or enhanced detection for ${item.failureMode}.`,
                actionResponsibility: 'Engineering',
                actionTargetDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                actionTaken: '',
                actionCompletionDate: ''
            };
        }
        return item;
    });

    // 3. Commit changes
    updateItems(updatedItems);
};
